"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencyConstants = exports.MarketConstants = exports.PeriodUnits = exports.Events = void 0;
var Events = {
  ADD_ITEM: 'px.headerCart.add',
  REMOVE_ITEM: 'px.headerCart.remove',
  ENABLE: 'px.headerCart.enable',
  PROPS: 'px.headerCart.props'
};
exports.Events = Events;
var PeriodUnits = {
  ONE_TIME: 'ONE_TIME'
};
exports.PeriodUnits = PeriodUnits;
var MarketConstants = {
  COOKIE_KEY: 'market',
  DEFAULT_MARKET_KEY: 'en'
};
exports.MarketConstants = MarketConstants;
var CurrencyConstants = {
  COOKIE_KEY: 'currency',
  DEFAULT_CURRENCY_KEY: 'USD'
};
exports.CurrencyConstants = CurrencyConstants;